import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Group } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<Group>>>;

const getAllIndividuals = (): ReturnType => {
    return Request.get(`/individuals`);
};

export default getAllIndividuals;
